import { computed, observable } from "mobx";
import { StoreClass } from "./Store";
import { shopUrl } from "../utils/url";


export function post(url, data){
    return fetch(url, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify(data)
    });
}
function get(url, params){
    var p = new URLSearchParams(params);
    var search = p.toString() ? `?${p.toString()}`: '';
    return fetch(url + search, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: "GET",
        // body: JSON.stringify(data)
    });
}

export class CartClass{
    store:StoreClass;

    constructor({store}){
        this.store = store;
    }
    @observable months = 36;
    
    @computed get config(){
        return this.store?.config;
    }
    @computed get basePrice(){

        var sum = 0;
        this.config.defaultConfiguration.forEach(({category_id, id}) => {
            const p = this.store.materials.find(m=>m.id === id && category_id === m.category_id);
            if(p){
                sum += parseFloat(p.price) || 0;
            }
        });
        return sum;
    }
    @computed get totalPrice(){
        
        var sum = 0;
        this.store.selectedMaterials.forEach(s=>{
            sum += s.fullPrice;
        });
        return sum;
    };
    @computed get installment() { 
        return  (this.totalPrice * 1.2 / this.months);
    } 

    @computed get deliveryTimeSummary(){
        var max = 1;
        this.store.selectedMaterials.forEach(s => {
            if(s.material.deliveryTime > max){
                max = s.material.deliveryTime;
            }
        })
        return max;
    }

    @computed get isValid(){
        return this.store.selectedMaterials.length > 2;
    }
    async addToCart(){
        // const token = window['prestashop'] ? prestashop.token : '';
        const token = window['leo_token'] ? window['leo_token'] : '';
        try {
            const base64Image = await this.store.saveScreenshoot();
            if(!base64Image){
                throw new Error('no image');
            }
            const response = await $.ajax({
                url: '/module/custommodifications/productPack', //URI will be /module/custommodifications/productPack
                // url: shopUrl('/module/custommodifications/productPack'), //URI will be /module/custommodifications/productPack
                type: 'POST',
                dataType: 'json',
                data: {
                    productIDs: this.store.selectedMaterials.map(p=>p.id), //prestashop product IDs
                    ajax: 1,
                    // image: img_response.url,
                    image: base64Image,
                    token: token,
                },
            }).promise()
            // const response = await post(`/module/custommodifications/productPack`,{
            //     productIDs: this.store.selectedMaterials.map(p=>p.id), //prestashop product IDs
            //     ajax: 1,
            //     image: img_response.url,
            //     token: token,
            // })
            // .then(r => r.json())
            .then(r => {
                if(window['prestashop']){
                    try {
                        const id = JSON.parse(r);
                        this.addToPrestaCart(id);
                    } catch (err) {
                        console.error(err);
                    }
                }else{
                    console.log('go to cart...');
                }
            });
        } catch (err) {
            console.error(err)
        }
    }

    async addToPrestaCart(id_product, totalQty=1) {
        const token = prestashop.static_token;
        const url = prestashop.urls.pages.cart;
        const query = 'controller=cart&add=1&action=add&ajax=true&token=' + token + '&id_product=' + id_product + '&id_customization=0&qty=' + totalQty;
        var controllerUrl = url.concat(query);
        var functionName = "addToCart";
        
        $.ajax({
            cache: false,
            data: query,
            success: function(resp) 
                {
                    // console.log(resp);
                    prestashop.emit('updateCart', {
                        reason: {}, resp: resp
                    });
                    window.location.href = prestashop.urls.pages.cart + '?action=show';
                },
                error: function(resp) {
                    // console.log(resp);
                    prestashop.emit('handleError', {eventType: 'addProductToCart', resp: resp});
                }
        });
    }

        
    async test(){
        const token = window['prestashop'] ? prestashop.token : '';
        try {
          
            const response = await post(`/module/custommodifications/productPack`,{
                productIDs: [23,24,25], //prestashop product IDs
                ajax: 1,
                token: token,
                
            })
            .then(r => r.json())
            .then(r => {
               console.log(r);
            });
        } catch (err) {
            console.error(err)
        }
    }

  
}